import { render, staticRenderFns } from "./CoordinatorApprove.vue?vue&type=template&id=db583446"
import script from "./CoordinatorApprove.vue?vue&type=script&lang=js"
export * from "./CoordinatorApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports